import {FORGOT_PASSWORD} from './ForgotPasswordMutation';
import {RETRIEVE_TOKEN} from './RetrieveTokenMutation';

const Mutations = {FORGOT_PASSWORD, RETRIEVE_TOKEN};

export {Mutations};
